import { USER_TOKEN_LS_EXPIRES_AT } from '@pco/constants/cookies';
import { useConfig } from '@pco/molecules/Config';
import { useSessionStore } from '@pco/stores/sessionStore';
import type { PropsWithChildren } from 'react';
import SessionTimeoutModal from '.';

interface UserSessionTimeOutModalProps extends PropsWithChildren {
	cookieDomain: string;
}

const USER_TIMEMOUT_MODAL_COPIES = {
	title: 'Your Log In Session Has Expired',
	subtitle: 'For your security, we’ve signed you out due to inactivity.',
	primaryLabel: 'Continue Shopping',
};

export const UserSessionTimeOutModal: React.FC<UserSessionTimeOutModalProps> = (
	props,
) => {
	const { userSessionExpired, setUserSessionExpired } = useSessionStore();
	const { REACT_APP_FORGEROCK_URL: forgeRockUrl, NODE_ENV } = useConfig();

	const handleContinueShopping = () => {
		const redirectUri = normalizeRedirectUri(
			window.location.pathname + window.location.search,
		);

		localStorage.removeItem(USER_TOKEN_LS_EXPIRES_AT);

		if (window?.pkce) {
			window.pkce.signOut(
				`https://${forgeRockUrl}/logout?post_logout_redirect_uri=${redirectUri}`,
				props.cookieDomain,
				NODE_ENV !== 'production' ? 'dev' : 'prod',
				false,
				'',
			);
		}

		setUserSessionExpired(false);
	};

	const handleOpenChange = (open: boolean) => {
		if (!open) {
			handleContinueShopping();
		}
	};

	return (
		<SessionTimeoutModal
			{...props}
			title={USER_TIMEMOUT_MODAL_COPIES.title}
			subtitle={USER_TIMEMOUT_MODAL_COPIES.title}
			isOpen={userSessionExpired}
			onOpenChange={handleOpenChange}
			primaryLabel={USER_TIMEMOUT_MODAL_COPIES.primaryLabel}
			onPrimaryClick={handleContinueShopping}
		/>
	);
};

function normalizeRedirectUri(uri: string | null): string | null {
	if (!uri) {
		return null;
	}

	try {
		const parsed = new URL(decodeURIComponent(uri));
		return encodeURIComponent(parsed.toString());
	} catch {
		let path = decodeURIComponent(uri);

		if (!path.startsWith('/')) {
			path = `/${path}`;
		}

		const { protocol, host } = window.location;
		const baseUrl = `${protocol}//${host}`;

		return encodeURIComponent(`${baseUrl}${path}`);
	}
}

export default UserSessionTimeOutModal;
